<template>
  <div>
    <template v-if="!isAuthenticated">
      <div class="cidades-empreendedoras-header">
        <img src="@/assets/img/sebrae-logo.png" width="100px" />
      </div>
      <div class="menus-selo d-flex justify-space-between">
        <selo-logo :semAuth="true"></selo-logo>
      </div>
    </template>

    <v-container v-if="mostrarTermo">
      <TermoDeUso @concordarOk="setCookie"></TermoDeUso>
    </v-container>
    <v-container v-else class="pa-6">
      <!-- Hero Section -->
      <v-row class="" justify="center">
        <v-col cols="12" md="10" lg="8">
          <div class="hero-section text-center">
            <h1
              class="font-weight-bold primary--text mb-3"
              style="font-size: 1.8rem !important"
            >
              Selo de Referência em Atendimento
              <br />
              Formulário de Inscrição ciclo - 2026
            </h1>
            <div class="hero-divider mx-auto"></div>
            <div class="text-center mb-6">
              <p class="text-body-1 grey--text text--darken-1 mb-0">
                Escolha uma das opções abaixo
              </p>
            </div>
          </div>
          <v-row justify="center">
            <div cols="12" sm="8" md="6">
              <v-btn-toggle
                v-model="tipoInscricao"
                class="choice-toggle d-flex"
                style="width: 100%"
                :data-has-selection="tipoInscricao ? 'true' : 'false'"
              >
                <v-btn
                  :value="'nova'"
                  class="choice-btn choice-btn--new flex-grow-1 pa-4 mr-6"
                  style="min-height: 90px"
                  @click="trocaTipoInscricao('nova')"
                  title="Use esse botão caso não tenha iniciado a inscrição no ciclo 2026"
                >
                  <div class="d-flex flex-column align-center">
                    <v-icon size="32" color="white" class="mb-2"
                      >mdi-plus-circle</v-icon
                    >
                    <span class="choice-btn-text font-weight-bold"
                      >Iniciar Inscrição</span
                    >
                    <span class="choice-btn-subtitle">Começar do zero</span>
                  </div>
                </v-btn>
                <v-btn
                  :value="'continuar'"
                  class="choice-btn choice-btn--continue flex-grow-1 pa-4"
                  style="min-height: 90px"
                  @click="trocaTipoInscricao('continuar')"
                  title="Use esse botão caso já tenha feito o processo inicial para criar sua senha de acesso ao formulário de inscrição e deseje continuar respondendo o formulário de inscrição."
                >
                  <div class="d-flex flex-column align-center">
                    <v-icon size="32" color="white" class="mb-2"
                      >mdi-refresh-circle</v-icon
                    >
                    <span class="choice-btn-text font-weight-bold"
                      >Continuar Inscrição</span
                    >

                    <span class="choice-btn-subtitle"
                      >Continuar preenchimento</span
                    >
                  </div>
                </v-btn>
              </v-btn-toggle>
            </div>
          </v-row>
        </v-col>
      </v-row>
      <!-- Escolha Inicial -->

      <v-row
        v-if="
          (bloquearTodasInscricoes || bloquearInscricoesNovas) &&
          tipoInscricao === 'nova'
        "
        justify="center"
        class="mt-8"
      >
        <v-col cols="12" md="10" lg="8">
          <v-card
            class="prazo-encerrado-card mx-auto"
            elevation="12"
            max-width="600"
          >
            <!-- Header com gradiente -->
            <div class="prazo-header">
              <div class="prazo-icon-wrapper">
                <div class="prazo-icon-circle">
                  <v-icon size="40" color="#ffffff"
                    >mdi-clock-alert-outline</v-icon
                  >
                </div>
              </div>

              <div class="prazo-content">
                <h2 class="prazo-title">Prazo Encerrado</h2>
                <p class="prazo-date">{{ dataFinal }}</p>
              </div>
            </div>

            <!-- Corpo da mensagem -->
            <v-card-text class="prazo-body">
              <div class="prazo-message">
                <p class="message-text">
                  <strong
                    >As inscrições para o ciclo 2026 foram encerradas.</strong
                  >
                </p>

                <p class="message-text">
                  Agradecemos imensamente pela sua participação e interesse no
                  <strong>Selo de Referência em Atendimento</strong>!
                </p>
              </div>

              <!-- Call to action -->
              <div class="prazo-actions">
                <v-btn
                  color="#667eea"
                  large
                  rounded
                  elevation="4"
                  style="color: white; font-weight: 600; text-transform: none"
                  @click="tipoInscricao = null"
                >
                  <v-icon left>mdi-arrow-left</v-icon>
                  Voltar ao Início
                </v-btn>
              </div>
            </v-card-text>

            <!-- Decoração -->
            <div class="prazo-decoration">
              <div class="decoration-wave"></div>
            </div>
          </v-card>
        </v-col>
      </v-row>
      <v-row
        justify="center"
        v-else-if="tipoInscricao === 'continuar' && !isAuthenticated"
        class="mt-8"
      >
        <v-col cols="12" md="10" lg="8">
          <div class="choice-section">
            <!-- Alerta para login se necessário -->
            <v-expand-transition>
              <div>
                <div class="login-required-container">
                  <div class="login-required-card">
                    <!-- Ícone Principal -->
                    <div class="login-icon-wrapper">
                      <div class="login-icon-circle">
                        <v-icon size="28" color="#ffffff"
                          >mdi-account-key</v-icon
                        >
                      </div>
                    </div>

                    <!-- Conteúdo -->
                    <div class="login-content">
                      <h3 class="login-title">Login Necessário</h3>
                      <p class="login-subtitle">
                        Para continuar uma inscrição existente
                      </p>
                      <p class="login-description">
                        É necessário fazer login na sua conta para acessar e
                        continuar uma inscrição que você já iniciou
                        anteriormente.
                      </p>
                    </div>

                    <!-- Botão de Ação -->
                    <div class="login-actions">
                      <v-btn
                        color="#e74c3c"
                        x-large
                        elevation="3"
                        class="login-action-btn"
                        @click="irParaLogin"
                      >
                        <v-icon left size="20">mdi-login</v-icon>
                        Fazer Login Agora
                      </v-btn>
                    </div>

                    <!-- Decoração -->
                    <div class="login-decoration">
                      <div class="decoration-circle decoration-circle-1"></div>
                      <div class="decoration-circle decoration-circle-2"></div>
                      <div class="decoration-circle decoration-circle-3"></div>
                    </div>
                  </div>
                </div>
              </div>
            </v-expand-transition>
          </div>
        </v-col>
      </v-row>

      <!-- Formulário Principal (só aparece após escolher) -->
      <v-row
        justify="center"
        v-else-if="
          tipoInscricao &&
          (tipoInscricao === 'nova' ||
            (tipoInscricao === 'continuar' && isAuthenticated))
        "
        class="mt-8"
      >
        <v-col cols="12" md="10" lg="8">
          <div class="choice-section">
            <v-expand-transition>
              <div>
                <v-row justify="center">
                  <v-col cols="12" lg="11">
                    <!-- Alert Info Box -->
                    <v-alert
                      dense
                      text
                      color="blue"
                      border="left"
                      icon="mdi-information-outline"
                      class="mb-4"
                      style="font-size: 13px"
                    >
                      <div>
                        <strong>Atenção:</strong> Para este ciclo, os dados
                        iniciais informados pela Sala/Parceiro no ciclo anterior
                        aparecerão previamente preenchidos no formulário. Caso
                        não sejam editados, as informações serão mantidas.
                        <br />
                        <br />
                        Caso o nome da Sala do Empreendedor ou do Parceiro
                        Sebrae não conste na lista de seleção, entre em contato
                        com o gestor estadual do Selo. O preenchimento da
                        inscrição só poderá continuar após a inclusão do nome da
                        sua instituição parceira.
                      </div>
                    </v-alert>

                    <div class="form-section">
                      <div class="text-center mb-6">
                        <p class="text-body-1 grey--text text--darken-1">
                          Preencha os dados abaixo para prosseguir
                        </p>
                      </div>

                      <v-row>
                        <v-col sm="6" cols="auto" md="3">
                          <div class="field-wrapper">
                            <h4
                              class="field-label mb-3 primary--text font-weight-bold"
                            >
                              <v-icon left color="primary" size="20"
                                >mdi-map-marker</v-icon
                              >
                              Estado (UF)
                            </h4>
                            <v-autocomplete
                              v-model="filters.uf"
                              :items="ufs"
                              label="Selecione a UF"
                              placeholder="Escolha sua UF..."
                              @change="trocaUf"
                              :clearable="false"
                              :rules="[obrigatorio]"
                              hide-details="auto"
                              outlined
                              dense
                              class="modern-input"
                            >
                              <template slot="no-data">
                                Nenhuma UF encontrada
                              </template>
                            </v-autocomplete>
                          </div>
                        </v-col>
                        <v-col sm="6" cols="auto" md="3">
                          <div class="field-wrapper">
                            <h4
                              class="field-label mb-3 primary--text font-weight-bold"
                            >
                              <v-icon left color="orange" size="20"
                                >mdi-office-building</v-icon
                              >
                              Tipo
                            </h4>
                            <v-autocomplete
                              v-model="filters.parceiro"
                              :items="tipoSala"
                              label="Selecione o tipo"
                              item-text="nome"
                              item-value="id"
                              placeholder="Escolha o tipo..."
                              @change="trocaTipoSala"
                              :clearable="false"
                              :rules="[obrigatorio]"
                              hide-details="auto"
                              outlined
                              dense
                              :disabled="!filters.uf"
                              class="modern-input"
                            >
                              <template slot="no-data">
                                Nenhum tipo encontrado
                              </template>
                            </v-autocomplete>
                          </div>
                        </v-col>
                        <v-col sm="6" cols="auto" md="4">
                          <div class="field-wrapper">
                            <h4
                              class="field-label mb-3 primary--text font-weight-bold"
                              v-if="!parceiroBool() && this.filters.parceiro"
                            >
                              Localize sua sala do empreendedor.
                            </h4>
                            <h4
                              class="field-label mb-3 primary--text font-weight-bold"
                              v-else-if="
                                parceiroBool() && this.filters.parceiro
                              "
                            >
                              Localize seu parceiro.
                            </h4>
                            <h4
                              class="field-label mb-3 primary--text font-weight-bold"
                              v-else
                            >
                              Sala do empreendedor/Parceiro
                            </h4>

                            <!-- <div>
                      <v-radio-group
                        v-model="filters.novoMunicipio"
                        row
                        hide-details="auto"
                        :rules="[obrigatorio]"
                        @change="trocaTipoMunicipio"
                        :disabled="!filters.parceiro"
                      >
                        <v-radio
                          :label="
                            parceiroBool()
                              ? 'Parceiro Existente'
                              : 'Sala Existente'
                          "
                          :value="1"
                        ></v-radio>
                      </v-radio-group>
                    </div> -->
                            <div v-if="filters.novoMunicipio == 2" class="mt-2">
                              <v-autocomplete
                                id="temas-select"
                                v-model="filters.municipios"
                                :items="municipiosFiltradosIbge"
                                label="Município"
                                item-text="nomeMunicipio"
                                item-value="idMunicipio_Ibge"
                                placeholder="Selecione..."
                                v-on:change="$emit('onChange')"
                                :clearable="false"
                                :rules="[
                                  filters.novoMunicipio == 2
                                    ? obrigatorio
                                    : true,
                                ]"
                                hide-details="auto"
                                outlined
                                :disabled="!filters.parceiro"
                                :return-object="true"
                              >
                                <template slot="no-data">
                                  {{
                                    parceiroBool()
                                      ? "Nenhum parceiro retornado"
                                      : "Nenhuma sala retornada"
                                  }}
                                </template>
                              </v-autocomplete>

                              <div class="mt-2">
                                <v-textField
                                  :label="
                                    parceiroBool()
                                      ? 'Nome do parceiro'
                                      : 'Nome da sala'
                                  "
                                  v-model="filters.nomeNovoMunicipio"
                                  hide-details="auto"
                                  outlined
                                  :rules="[
                                    filters.novoMunicipio == 2
                                      ? obrigatorio
                                      : true,
                                  ]"
                                  :disabled="!filters.parceiro"
                                >
                                </v-textField>
                              </div>
                            </div>
                            <div
                              v-else-if="filters.novoMunicipio == 1"
                              class="mt-2"
                            >
                              <v-autocomplete
                                id="temas-select"
                                v-model="filters.municipios"
                                :items="municipiosFiltrados"
                                :label="parceiroBool() ? 'Parceiro' : 'Sala'"
                                item-text="nome"
                                item-value="municipioId"
                                placeholder="Selecione..."
                                v-on:change="$emit('onChange')"
                                :clearable="false"
                                :rules="[
                                  filters.novoMunicipio == 2
                                    ? obrigatorio
                                    : true,
                                ]"
                                outlined
                                dense
                                hide-details="auto"
                                :disabled="!filters.parceiro"
                                :return-object="true"
                              >
                                <template slot="no-data">
                                  {{
                                    parceiroBool()
                                      ? "Nenhum parceiro retornado"
                                      : "Nenhuma sala retornada"
                                  }}
                                </template>
                                <template v-slot:prepend-item>
                                  <v-list-item
                                    class="px-3 py-3"
                                    style="
                                      background-color: #fff3cd;
                                      border-left: 4px solid #ffc107;
                                    "
                                  >
                                    <v-list-item-content>
                                      <v-list-item-subtitle
                                        class="text-wrap"
                                        style="
                                          font-size: 12px;
                                          color: #856404;
                                          line-height: 1.5;
                                        "
                                      >
                                        <v-icon
                                          small
                                          color="#ffc107"
                                          class="mr-1"
                                          >mdi-alert-circle-outline</v-icon
                                        >
                                        <strong
                                          >Não encontrou sua
                                          Sala/Parceiro?</strong
                                        ><br />
                                        Entre em contato com o gestor estadual
                                        do Selo.
                                      </v-list-item-subtitle>
                                    </v-list-item-content>
                                  </v-list-item>
                                </template>
                              </v-autocomplete>
                            </div>
                          </div>
                        </v-col>
                        <v-col cols="12" md="2" style="margin-top: auto">
                          <div class="button-wrapper text-center">
                            <v-btn
                              color="primary"
                              block
                              class="action-button elevation-4"
                              @click="fazerDiagnostico()"
                              :disabled="
                                !filters.uf ||
                                !filters.parceiro ||
                                !filters.municipios
                              "
                            >
                              <v-icon left size="24">mdi-magnify</v-icon>
                              <div class="d-flex flex-column align-center">
                                <span class="button-text">Buscar</span>
                                <span class="button-subtext">Inscrição</span>
                              </div>
                            </v-btn>
                          </div>
                        </v-col>
                      </v-row>
                    </div>
                  </v-col>
                </v-row>
              </div>
            </v-expand-transition>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <Diagnostico
      v-if="municipioIdEscolhido || municipioIdEscolhido == 0"
      :municipioIdProp="municipioIdEscolhido"
      :uf="ufEscolhida"
      :parceiro="parceiroEscolhido"
      :dataFinal="dataFinal"
    ></Diagnostico>
  </div>
</template>
<script>
import SeloLogo from "@/modules/seloLogo/seloLogo.vue";
import Diagnostico from "./List";
import { cityAPI, cityIBGEAPI } from "@/modules/city";
import { mapActions, mapGetters } from "vuex";
import Swal from "sweetalert2";
import TermoDeUso from "./TermosdeUso";
import moment from "moment";
import { setCookie, getCookie } from "@/helpers/cookies";
import { configuracoesAPI } from "@/modules/configuracao";

export default {
  components: {
    SeloLogo,
    Diagnostico,
    TermoDeUso,
  },
  computed: {
    ...mapGetters(["isAuthenticated"]),
    dataFinal() {
      return "30/04/2026 17:59";
    },
  },

  data() {
    return {
      mostrarTermo: true,
      tipoInscricao: null, // 'nova' ou 'continuar'
      obrigatorio: (v) => !!v || "Campo Obrigatório",
      tipoSala: [
        { id: 1, nome: "Sala do Empreendedor" },
        { id: 2, nome: "Parceiros" },
      ],
      filters: { novoMunicipio: 1 },
      mostrarDiagnostico: false,
      municipiosFiltrados: [],
      municipiosFiltradosIbge: [],
      user: localStorage.getItem("user")
        ? JSON.parse(localStorage.getItem("user"))
        : {},
      formValid: true,
      municipioIdEscolhido: null,
      ufs: [],
      ufEscolhida: null,
      parceiroEscolhido: null,
      bloquearTodasInscricoes: false,
      bloquearInscricoesNovas: false,
    };
  },
  async mounted() {
    const config = await configuracoesAPI.get();

    this.bloquearTodasInscricoes =
      config.data.find((item) => item.configuracaoId == 13).valor === "true";

    this.bloquearInscricoesNovas =
      config.data.find((item) => item.configuracaoId == 14).valor === "true";
    if (getCookie("termos")) {
      this.mostrarTermo = false;
    }
  },
  methods: {
    ...mapActions(["setLoading"]),
    irParaLogin() {
      this.$router.push("/auth/login");
    },
    trocaTipoInscricao(tipo) {
      this.filters.parceiro = null;
      this.filters.novoMunicipio = 1;
      this.filters.nomeNovoMunicipio = null;
      this.filters.uf = null;
      this.municipioIdEscolhido = null;
      if (tipo == "continuar") {
        this.obterDadosIniciais(this.user.email);
      } else {
        this.obterDadosIniciais();
      }
    },
    parceiroBool() {
      return this.filters.parceiro == 1 ? false : true;
    },
    trocaUf(e) {
      this.filters.parceiro = null;
      this.filters.novoMunicipio = 1;
      this.filters.nomeNovoMunicipio = null;
      this.filters.uf = e;
      this.$forceUpdate();
    },
    trocaTipoSala() {
      this.getMunicipio();
      // this.getMunicipioIbge();
      if (!this.filters.novoMunicipio) {
        this.filters.novoMunicipio = 1;
      }
    },
    trocaTipoMunicipio(e) {
      this.mostrarDiagnostico = false;
      if (e == 1) {
        this.getMunicipio();
        this.filters.nomeNovoMunicipio = null;
      }
      if (e == 2) {
        this.getMunicipioIbge();
      }
    },
    async check() {
      const isValid = await this.$refs.form.validate();
      return isValid;
    },
    alertaCriarMunicipio() {
      Swal.fire({
        title: "Atenção!",
        text: `Você realmente deseja criar a ${
          this.parceiroBool() ? "novo parceiro" : "nova sala"
        }  ${this.filters.municipios.nomeMunicipio} - ${
          this.filters.nomeNovoMunicipio
        } /${this.filters.uf}`,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Não",
        confirmButtonText: "Sim",
      }).then((result) => {
        if (result.isConfirmed) {
          this.criarMunicipio();
        }
      });
    },
    async criarMunicipio() {
      try {
        this.setLoading(true);
        const { data: municipios } = await cityAPI.cadastrarMunicipio({
          parceiro: this.parceiroBool(),
          nome: `${this.filters.municipios.nomeMunicipio} - ${this.filters.nomeNovoMunicipio}`,
          uf: this.filters.uf,
          desabilitado: false,
        });

        this.municipioIdEscolhido = municipios.municipioId;
        this.ufEscolhida = municipios.uf;
        this.parceiroEscolhido = this.parceiroBool();

        this.setLoading(false);
      } catch (error) {
        console.log("getMunicipio error ", error);
        this.$notification.error("Erro ao obter salas");
        this.setLoading(false);
      }
    },
    async fazerDiagnostico() {
      this.mostrarDiagnostico = true;

      if (this.filters.novoMunicipio == 2) {
        this.alertaCriarMunicipio();
      } else {
        this.municipioIdEscolhido = this.filters.municipios.municipioId;
        this.ufEscolhida = this.filters.municipios.uf;
        this.parceiroEscolhido = this.parceiroBool();
      }
    },
    async getMunicipio() {
      try {
        this.setLoading(true);
        const { data: municipios } = await cityAPI.obterMunicipioUfParceiro(
          this.filters.uf,
          this.parceiroBool(),
          !this.isAuthenticated || this.tipoInscricao == "nova",
          this.user && this.user.email
        );
        this.municipiosFiltrados = municipios;
        this.setLoading(false);
      } catch (error) {
        console.log("getMunicipio error ", error);
        this.$notification.error("Erro ao obter salas");
        this.setLoading(false);
      }
    },
    async getMunicipioIbge() {
      try {
        this.setLoading(true);
        const { data: municipios } = await cityIBGEAPI.getByUf(this.filters.uf);
        this.municipiosFiltradosIbge = municipios;
        this.setLoading(false);
      } catch (error) {
        console.log("getMunicipio error ", error);
        this.$notification.error("Erro ao obter salas");
        this.setLoading(false);
      }
    },

    async obterDadosIniciais(email) {
      try {
        this.setLoading(true);
        const { data: ufs } = await cityAPI.obterUfsMunicipios(email);
        this.ufs = ufs;
        this.setLoading(false);
      } catch (error) {
        console.log("obterDadosIniciais error ", error);

        this.setLoading(false);
        this.$notification.error("Erro ao obter ufs");
      }
    },
    setCookie() {
      var thirtydays = 1000 * 60 * 60 * 24;
      var expires = new Date(new Date().valueOf() + thirtydays);
      setCookie(expires, "termos");
      this.mostrarTermo = false;
    },
  },
};
</script>
<style scoped lang="scss">
.menus-selo {
  background: var(--corPrimaria);
  padding: 20px;
}

/* Hero Section */
.hero-section {
  position: relative;
  overflow: hidden;
}

.hero-section::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(
      circle at 20% 80%,
      rgba(255, 255, 255, 0.1) 0%,
      transparent 50%
    ),
    radial-gradient(
      circle at 80% 20%,
      rgba(255, 255, 255, 0.1) 0%,
      transparent 50%
    );
  pointer-events: none;
}

.hero-avatar {
  background: linear-gradient(135deg, #4caf50 0%, #66bb6a 100%);
  position: relative;
  z-index: 1;
}

.choice-toggle .v-btn {
  border: none !important;
  transition: all 0.3s ease;
}

.choice-btn-text {
  font-size: 16px;
  line-height: 1.2;
}

.choice-btn-subtitle {
  font-size: 12px;
  opacity: 0.9;
  font-weight: normal;
}

.choice-btn--new {
  background: #10b981 !important;
  color: white !important;
}
.title-inscricao {
  font-size: 1.5rem !important;
}

/* Quando NENHUM botão está selecionado, ambos têm cor */
.choice-btn--new:not(.v-btn--active) {
  background: #10b981 !important;
  opacity: 1;
}

/* Quando um botão ESTÁ selecionado, o ativo fica mais escuro */
.choice-btn--new.v-btn--active {
  background: #059669 !important;
  opacity: 1;
}

/* Se há uma seleção E este botão NÃO está ativo, fica cinza */
[data-has-selection="true"] .choice-btn--new:not(.v-btn--active) {
  background: #9ca3af !important;
  opacity: 0.6;
}

.choice-btn--continue {
  background: #3b82f6 !important;
  color: white !important;
}

/* Quando NENHUM botão está selecionado, ambos têm cor */
.choice-btn--continue:not(.v-btn--active) {
  background: #3b82f6 !important;
  opacity: 1;
}

/* Quando um botão ESTÁ selecionado, o ativo fica mais escuro */
.choice-btn--continue.v-btn--active {
  background: #2563eb !important;
  opacity: 1;
}

/* Se há uma seleção E este botão NÃO está ativo, fica cinza */
[data-has-selection="true"] .choice-btn--continue:not(.v-btn--active) {
  background: #9ca3af !important;
  opacity: 0.6;
}

/* Login Required Styles */
.login-required-container {
  display: flex;
  justify-content: center;
  margin: 32px 0;
}

.login-required-card {
  position: relative;
  max-width: 500px;
  width: 100%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 20px;
  padding: 40px 32px;
  box-shadow: 0 20px 40px rgba(102, 126, 234, 0.3);
  text-align: center;
  overflow: hidden;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.login-required-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 25px 50px rgba(102, 126, 234, 0.4);
}

.login-icon-wrapper {
  margin-bottom: 24px;
  display: flex;
  justify-content: center;
}

.login-icon-circle {
  width: 80px;
  height: 80px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(10px);
  border: 2px solid rgba(255, 255, 255, 0.3);
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.4);
  }
  70% {
    transform: scale(1.05);
    box-shadow: 0 0 0 10px rgba(255, 255, 255, 0);
  }
  100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);
  }
}

.login-content {
  color: white;
  margin-bottom: 32px;
}

.login-title {
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 8px;
  color: #ffffff;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.login-subtitle {
  font-size: 16px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.9);
  margin-bottom: 16px;
}

.login-description {
  font-size: 14px;
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.8);
  margin-bottom: 0;
}

.login-actions {
  margin-bottom: 8px;
}

.login-action-btn {
  background: #e74c3c !important;
  color: white !important;
  font-weight: 600 !important;
  font-size: 16px !important;
  border-radius: 12px !important;
  padding: 16px 32px !important;
  text-transform: none !important;
  letter-spacing: 0.5px !important;
  transition: all 0.3s ease !important;
  border: 2px solid transparent !important;
}

.login-action-btn:hover {
  background: #c0392b !important;
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(231, 76, 60, 0.4) !important;
  border-color: rgba(255, 255, 255, 0.2) !important;
}

.login-action-btn:active {
  transform: translateY(0);
}

/* Elementos Decorativos */
.login-decoration {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  overflow: hidden;
}

.decoration-circle {
  position: absolute;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  animation: float 6s ease-in-out infinite;
}

.decoration-circle-1 {
  width: 60px;
  height: 60px;
  top: -30px;
  right: -30px;
  animation-delay: 0s;
}

.decoration-circle-2 {
  width: 40px;
  height: 40px;
  bottom: -20px;
  left: -20px;
  animation-delay: 2s;
}

.decoration-circle-3 {
  width: 80px;
  height: 80px;
  top: 50%;
  right: -40px;
  animation-delay: 4s;
}

@keyframes float {
  0%,
  100% {
    transform: translateY(0px) rotate(0deg);
  }
  50% {
    transform: translateY(-10px) rotate(180deg);
  }
}

/* Form Inputs */
.form-inputs .v-select,
.form-inputs .v-text-field {
  margin-bottom: 20px;
}

/* Radio Group */
.radio-group {
  background: white;
}

.radio-item {
  border: 1px solid #e2e8f0;
  transition: all 0.2s ease;
}

.radio-item:hover {
  border-color: #4caf50;
  background: #f8fffe;
}

.radio-item.active {
  background: #f0fdf4;
  border-color: #4caf50;
}

.radio-text {
  font-size: 14px;
  line-height: 1.4;
  color: #374151;
}

/* Submit Button */
.submit-btn {
  background: #4caf50 !important;
  color: white !important;
  font-weight: 600;
  padding: 12px 32px;
  min-height: 50px;
}

.submit-btn:hover {
  background: #43a047 !important;
}

.submit-btn:disabled {
  background: #e5e7eb !important;
  color: #9ca3af !important;
}

/* Responsive */
@media (max-width: 768px) {
  .hero-title {
    font-size: 28px;
  }

  .hero-subtitle {
    font-size: 18px;
  }

  .choice-btn-text {
    font-size: 14px;
  }
}

/* Form Card */
.form-card {
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  border: 1px solid #e2e8f0;
}

/* Field Styling */
.field-wrapper {
  height: 100%;
}

.field-label {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.modern-input.v-text-field--outlined > .v-input__control > .v-input__slot {
  border-radius: 12px;
  border: 2px solid #e2e8f0;
}

.modern-input.v-text-field--outlined.v-input--is-focused
  > .v-input__control
  > .v-input__slot {
  border-color: var(--v-primary-base);
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

/* Instructions Section */
.instructions-section {
  background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
  border: 1px solid #93c5fd;
}

.instruction-text {
  color: #1e40af;
  font-size: 14px;
  line-height: 1.4;
}

/* Radio Section */
.radio-section {
  background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%);
  border: 1px solid #86efac;
}

.radio-option {
  background: white;
  border: 1px solid #e5e7eb;
  transition: all 0.3s ease;
}

.radio-option:hover {
  border-color: #d1d5db;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* Action Button */
.action-button {
  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%) !important;
  border-radius: 16px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  box-shadow: 0 8px 24px rgba(59, 130, 246, 0.3) !important;
  transition: all 0.3s ease !important;
  &.v-btn:not(.v-btn--round).v-size--default {
    height: fit-content;
    padding: 8px;
  }
}

.action-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 32px rgba(59, 130, 246, 0.4) !important;
}

.action-button:disabled {
  background: linear-gradient(135deg, #e2e8f0 0%, #cbd5e1 100%) !important;
  color: #64748b !important;
  box-shadow: none !important;
  transform: none !important;
}

.button-text {
  font-size: 16px;
  font-weight: 700;
  line-height: 1;
}

.button-subtext {
  font-size: 12px;
  font-weight: 400;
  opacity: 0.9;
  line-height: 1;
}

/* Conditional Sections */
.conditional-section {
  background: linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%);
  border: 2px solid #fbbf24;
}

.conditional-section-alt {
  background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%);
  border: 2px solid #22c55e;
}

/* Utilities */
.rounded-xl {
  border-radius: 20px !important;
}

.rounded-lg {
  border-radius: 12px !important;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .hero-section {
    padding: 2rem !important;
  }

  .form-card {
    padding: 1.5rem !important;
  }

  .action-button {
    margin-top: 1rem;
  }

  .field-label {
    font-size: 14px;
  }
}

/* Transitions */
.v-btn,
.v-card,
div[class*="-section"],
div[class*="-option"],
div[class*="-wrapper"] {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

/* Prazo Encerrado Styles */
.prazo-encerrado-card {
  border-radius: 20px !important;
  overflow: hidden;
  position: relative;
  background: white;
  border: none !important;
  box-shadow: 0 20px 40px rgba(255, 99, 71, 0.15) !important;
}

.prazo-header {
  background: linear-gradient(135deg, #ff6347 0%, #ff4500 100%);
  padding: 32px 24px;
  display: flex;
  align-items: center;
  gap: 20px;
  position: relative;
  overflow: hidden;
}

.prazo-header::before {
  content: "";
  position: absolute;
  top: -50%;
  right: -10%;
  width: 100px;
  height: 100px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  animation: float 6s ease-in-out infinite;
}

.prazo-icon-wrapper {
  flex-shrink: 0;
}

.prazo-icon-circle {
  width: 80px;
  height: 80px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(10px);
  border: 2px solid rgba(255, 255, 255, 0.3);
  animation: pulse 3s infinite;
}

.prazo-content {
  flex: 1;
  color: white;
}

.prazo-title {
  font-size: 28px;
  font-weight: 700;
  margin: 0 0 8px 0;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.prazo-date {
  font-size: 16px;
  font-weight: 500;
  margin: 0;
  opacity: 0.9;
  background: rgba(255, 255, 255, 0.2);
  padding: 8px 16px;
  border-radius: 20px;
  display: inline-block;
  backdrop-filter: blur(10px);
}

.prazo-body {
  padding: 40px 32px !important;
  text-align: center;
}

.prazo-message {
  margin-bottom: 32px;
}

.message-text {
  font-size: 16px;
  line-height: 1.6;
  color: #374151;
  margin-bottom: 16px;
}

.message-text:last-of-type {
  margin-bottom: 24px;
}

.next-steps {
  background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%);
  border-radius: 16px;
  padding: 24px;
  margin: 24px 0;
  border: 1px solid #86efac;
}

.next-step-item {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
  font-size: 14px;
  color: #374151;
  font-weight: 500;
}

.next-step-item:last-child {
  margin-bottom: 0;
}

.prazo-actions {
  margin-top: 24px;
}

.prazo-decoration {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 6px;
  overflow: hidden;
}

.decoration-wave {
  position: absolute;
  bottom: 0;
  left: -100%;
  width: 200%;
  height: 100%;
  background: linear-gradient(
    90deg,
    #ff6347 0%,
    #ff4500 25%,
    #ff6347 50%,
    #ff4500 75%,
    #ff6347 100%
  );
  animation: wave 3s linear infinite;
}

@keyframes wave {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(50%);
  }
}

@keyframes float {
  0%,
  100% {
    transform: translateY(0px) rotate(0deg);
  }
  50% {
    transform: translateY(-10px) rotate(180deg);
  }
}

@keyframes pulse {
  0% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.4);
  }
  70% {
    transform: scale(1.05);
    box-shadow: 0 0 0 10px rgba(255, 255, 255, 0);
  }
  100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);
  }
}

/* Responsive para prazo encerrado */
@media (max-width: 768px) {
  .prazo-header {
    flex-direction: column;
    text-align: center;
    gap: 16px;
    padding: 24px 16px;
  }

  .prazo-body {
    padding: 24px 16px !important;
  }

  .prazo-title {
    font-size: 24px;
  }

  .prazo-icon-circle {
    width: 60px;
    height: 60px;
  }

  .prazo-icon-circle .v-icon {
    font-size: 30px !important;
  }
}
</style>
